
class ServerConnector {

	async postData(json_data, success, failed) {

		const accessKey = localStorage.getItem("access_key");

		if (accessKey) {
			json_data["_access_key"] = accessKey;
		}

		if (json_data._action_code !== "APP_LOGIN") {
			json_data["user_id"] = localStorage.getItem("user_id");
			json_data["password"] = localStorage.getItem("password");
		}

		const requestOptions = {
			method: 'POST',
			headers: {
				// 'Content-Type': 'application/json'
			},
			body: JSON.stringify(json_data)
		};

		const urlPath = getUrlPath();
		consoleData("Request for " + json_data._action_code + ": ");
		consoleData(urlPath);
		consoleData(requestOptions);

		fetch(urlPath, requestOptions)
			.then(response => response.json())
			.then((data) => {

				consoleData("Response for " + json_data._action_code + ": ");
				consoleData(data);

				if (data._access_key) {
					localStorage.setItem("access_key", data._access_key);
				}

				if (data.status === "SUCCESS") {

					if (success != null) {
						success(data);
					}
				}
				else {
					if (failed != null) {
						failed(data.err_cd, data.msg, data);
					}
				}
			}).catch((error) => {

				consoleData("Response for " + json_data._action_code + ": ");
				consoleData(error);

				if (error === "TypeError: Failed to fetch") {
					error = "Could not connect to the server. Please try again";
				}
				else if (error === "SyntaxError: Unexpected token < in JSON at position 0") {
					error = "Generic Failure";
				}
				else {
					error = "Generic Failure";
				}

				if (failed != null) {
					failed("FAILED", error, null);
				}
			});
	}

	async postDataMultiPart(dataHashMap, imageHashMap, success, failed) {

		const accessKey = localStorage.getItem("access_key");

		if (accessKey) {
			dataHashMap["_access_key"] = accessKey;
		}

		dataHashMap["user_id"] = localStorage.getItem("user_id");
		dataHashMap["password"] = localStorage.getItem("password");

		var formData = new FormData();

		var index = 0;
		for (var key in imageHashMap) {
			formData.append("file" + index, imageHashMap[key], imageHashMap[key].name);
			index++;
		}

		var parameters = "";
		for (var key in dataHashMap) {
			if (parameters.length != 0) {
				parameters += "&";
			}
			parameters += key + "=" + dataHashMap[key];
		}

		const requestOptions = {
			method: 'POST',
			body: formData
		};

		consoleData(getUrlPath() + "?" + parameters);
		consoleData(requestOptions);

		fetch(getUrlPath() + "?" + parameters, requestOptions)
			.then(response => response.json())
			.then((data) => {

				consoleData("Response for " + dataHashMap._action_code + ": ");
				consoleData(data);

				try {
					if (data._access_key && data._access_key.length > 0) {
						appData["_access_key"] = data._access_key;

						if (appData.appDataBackupEnable) {
							localStorage.setItem("app_data", JSON.stringify(appData));
						}
					}
				} catch (err) { }

				if (data.status == "SUCCESS") {
					if (success != null) {
						success(data);
					}
				}
				else {
					if (failed != null) {
						failed(data.err_cd, data.msg, data);
					}
				}
			}).catch((error) => {

				consoleData("Response for " + dataHashMap._action_code + ": ");
				consoleData(error);

				if (error == "TypeError: Failed to fetch") {
					error = "Could not connect to the server. Please try again";
				}
				else if (error == "SyntaxError: Unexpected token < in JSON at position 0") {
					error = "Generic Failure";
				}

				if (failed != null) {
					failed("FAILED", error, null);
				}
			});
	}

	async postDataMultiPartCustom(dataHashMap, imageHashMap, success, failed) {

		const accessKey = localStorage.getItem("access_key");

		if (accessKey) {
			dataHashMap["_access_key"] = accessKey;
		}

		dataHashMap["user_id"] = localStorage.getItem("user_id");
		dataHashMap["password"] = localStorage.getItem("password");

		var formData = new FormData();

		imageHashMap.map((object, index) => {
			formData.append(object.fieldName, object.file, object.fileName);
		});

		var parameters = "";
		for (var key in dataHashMap) {
			if (parameters.length != 0) {
				parameters += "&";
			}
			parameters += key + "=" + dataHashMap[key];
		}

		const requestOptions = {
			method: 'POST',
			body: formData
		};

		consoleData(getUrlPath() + "?" + parameters);
		consoleData(requestOptions);

		fetch(getUrlPath() + "?" + parameters, requestOptions)
			.then(response => response.json())
			.then((data) => {

				consoleData("Response for " + dataHashMap._action_code + ": ");
				consoleData(data);

				try {
					if (data._access_key && data._access_key.length > 0) {
						appData["_access_key"] = data._access_key;

						if (appData.appDataBackupEnable) {
							localStorage.setItem("app_data", JSON.stringify(appData));
						}
					}
				} catch (err) { }

				if (data.status == "SUCCESS") {
					if (success != null) {
						success(data);
					}
				}
				else {
					if (failed != null) {
						failed(data.err_cd, data.msg, data);
					}
				}
			}).catch((error) => {

				consoleData("Response for " + dataHashMap._action_code + ": ");
				consoleData(error);

				if (error == "TypeError: Failed to fetch") {
					error = "Could not connect to the server. Please try again";
				}
				else if (error == "SyntaxError: Unexpected token < in JSON at position 0") {
					error = "Generic Failure";
				}

				if (failed != null) {
					failed("FAILED", error, null);
				}
			});
	}
}

function consoleData(data) {
	// console.log(data);
}

function getUrlPath() {

	return `${window.location.origin.toString()}/doubtapp/adminservice`;
	// return "http://www.archimageworks.com:7000/doubtapp/adminservice";
	// return "https://www.doubtzap.com/doubtapp/adminservice";

}

export default ServerConnector;
